// extracted by mini-css-extract-plugin
export default {"row":"viewTask_row__0vnf3","col":"viewTask_col__R3y-t","card":"viewTask_card__EJ3HJ"};